import { MeterPoint } from '../../../model/meter-point.model';
import { IZaehlpunkt } from '../../../model/meter-point-http.model';
import { Produktdaten } from '../../../../generated/model/produktdaten.model';
import ProduktEnum = Produktdaten.ProduktEnum;

function mapMeterPointToProduktdaten(zaehlpunkt: MeterPoint): Produktdaten {
  return {
    zaehlpunktnummer: zaehlpunkt.zaehlpunktnummer,
    vertragsnummer: zaehlpunkt.vertragsnummer,
    zaehlerNr: zaehlpunkt.zaehlerNr,
    produkt: mapSparteToProdukt(zaehlpunkt),
    adresse: {
      ort: zaehlpunkt.adresse?.city ?? '',
      plz: zaehlpunkt.adresse?.postcode ?? '',
      strasse: zaehlpunkt.adresse?.street ?? '',
      hausnummer: zaehlpunkt.adresse?.streetNumber ?? '',
      stiege: zaehlpunkt.adresse?.block ?? '',
      tuernummer: zaehlpunkt.adresse?.doorNumber ?? '',
    },
  };
}

function mapIZaehlpunktToProduktdaten(zaehlpunkt: IZaehlpunkt): Produktdaten {
  return {
    vertragsnummer: zaehlpunkt.vertragsnummer,
    zaehlpunktnummer: zaehlpunkt.zaehlpunktnummer,
    zaehlerNr: zaehlpunkt.zaehlerNr,
    produkt: mapSparteToProdukt(zaehlpunkt),
    adresse: {
      ort: zaehlpunkt.adresse?.ort ?? '',
      plz: zaehlpunkt.adresse?.plz ?? '',
      strasse: zaehlpunkt.adresse?.strasse ?? '',
      hausnummer: zaehlpunkt.adresse?.hausnummer ?? '',
      stiege: zaehlpunkt.adresse?.stiege ?? '',
      tuernummer: zaehlpunkt.adresse?.top ?? '',
    },
  };
}

function mapSparteToProdukt(zaehlpunkt: IZaehlpunkt | MeterPoint): ProduktEnum {
  return zaehlpunkt.sparte === 'Strom' ? ProduktEnum.STROM : ProduktEnum.GAS;
}

function mapToProduktdaten(zaehlpunkt: IZaehlpunkt | MeterPoint): Produktdaten {
  return zaehlpunkt instanceof MeterPoint ? mapMeterPointToProduktdaten(zaehlpunkt) : mapIZaehlpunktToProduktdaten(zaehlpunkt);
}

export { mapToProduktdaten };
